var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoAdsGlobal = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.996 35.5902C28.1608 35.5902 35.5902 28.1607 35.5902 18.996C35.5902 9.83126 28.1608 2.40179 18.996 2.40179C9.83132 2.40179 2.40186 9.83126 2.40186 18.996C2.40186 28.1607 9.83132 35.5902 18.996 35.5902Z",
  stroke: "#12CCA8",
  strokeWidth: 3.5,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.27161 30.7284L30.7285 7.27155",
  stroke: "#12CCA8",
  strokeWidth: 3.5,
  strokeMiterlimit: 10
})));
export default SvgNoAdsGlobal;